'use client'
import { FaSearch } from 'react-icons/fa'
import { useState } from 'react'
import Link from 'next/link'

const IdFilter = ({ dictionary, lang }) => {

    const [id, setId] = useState('')

    return (
        <div className='w-full flex flex-row items-center justify-start'>
            <label className='text-secondary text-sm pl-1 mr-1'>{dictionary.filter.id}:</label>
            <div className='flex flex-row'>
                {/* <div className='z-1 relative w-full cursor-default overflow-hidden rounded-l-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'> */}
                {/* <input
                    className='w-full rounded-l-lg border-[1px] border-forth text-secondary py-[1px] pl-2 text-sm leading-5 focus:ring-0'
                    placeholder={dictionary.filter.enterListingId}
                    type='text'
                    name='id'
                    value={id}
                    onChange={(e) => setId(e.target.value)}
                /> */}
                {/* </div> */}
                <Link href={`/properties/${id}`}>
                    <button className='bg-maincolor p-2 rounded-r-md border-none' id="id" aria-label="Search by ID" >
                        <FaSearch
                            color='white'
                        />
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default IdFilter